import axios from 'axios';

import { httpClient } from './client';

export type CityStateLookupResult = {
  city: string;
  state: string;
  postalCode: string;
  countryCode: string;
};

/**
 * Looks up city/state for a postal code via WebV3Api's `GET /address/city-state`, which proxies
 * to the internal address validation service (IAV). Resolves `null` when the postal code doesn't
 * resolve to a city/state (404) or fails validation (400) — callers treat that as "no autofill,"
 * not an error. Pass an `AbortSignal` so a caller re-requesting on each keystroke can cancel the
 * prior in-flight request and avoid a stale response clobbering a newer one.
 */
export const getCityStateFromPostalCode = async (
  postalCode: string,
  countryCode: string,
  signal?: AbortSignal,
): Promise<CityStateLookupResult | null> => {
  try {
    const response = await httpClient.get<CityStateLookupResult>('/address/city-state', {
      params: { postalCode, countryCode },
      signal,
    });
    return response.data ?? null;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 400) {
      return null;
    }
    throw error;
  }
};
